import React, {PropTypes as T} from 'react';
import filtersActions from '../../../../actions/edpfilters';
import withDevice from '../../../common/withDeviceHOC';
import translate from '../../../../utils/translate';

export class ISMFiltersPriceCategory extends React.Component {
  static propTypes = {
    id:          T.string,
    disabled:    T.bool,
    isActive:    T.bool,
    isAvailable: T.bool,
    code:        T.string,
    priceRange:  T.string,
    chargeRange: T.string,
    isMobile:    T.bool
  };

  togglePriceCategory = () => {
    filtersActions.updateActiveCategory(this.props.id);
  };

  renderUnavailableMsg = () => {
    if (this.props.disabled) {
      return <p>{translate('pageTranslations', 'TODO')}</p>;
    }
  };

  // Generates the service fee message for display in the filter.
  // This is not rendered on mobile.
  renderServiceChargeMessage = () => {
    if (this.props.isMobile === false &&
      this.props.chargeRange &&
      this.props.chargeRange.length) {
      return <p
        className="pricefilter__category__charges"
        data-component="price-category-fee-message">{this.props.chargeRange}</p>;
    }
  };

  render () {
    var className = 'pricefilter__category';
    className += this.props.isActive ? ' is-active' : '';
    className += this.props.isAvailable && !this.props.disabled ? ' is-available' : '';
    className += this.props.id === null ? ' is-all' : '';
    var priceCategoryId = this.props.id ? this.props.id : 'all';

    return (
      <li
        className={className}
        data-component="price-category-filter"
        data-price-category={priceCategoryId}>
        <button
          className="pricefilter__category__btn"
          onClick={this.togglePriceCategory}
          data-component="price-category-trigger">
          <h3 className="pricefilter__category__name">{this.props.code}</h3>
          <p className="pricefilter__category__price">{this.props.priceRange}</p>
          {this.renderServiceChargeMessage()}
          {this.renderUnavailableMsg()}
        </button>
      </li>
    );
  }
}

export default withDevice(ISMFiltersPriceCategory);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/sidebar/pricecategory/index.js